/* eslint-disable warp-drive/no-legacy-request-patterns */
import Controller from '@ember/controller';
import { action, set } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class LinkSiblingsController extends Controller {
  @service
  session;

  @service
  paperToaster;

  @tracked
  isProcessing = false;

  @action
  removeSibling(data, toRemove) {
    // siblings is a plain array; reassign it so the list re-renders.
    set(
      data,
      'siblings',
      data.siblings.filter((sibling) => sibling !== toRemove),
    );
  }

  @action
  saveAll() {
    this.isProcessing = true;
    let promises = [];
    this.model.potential.forEach((row) => {
      if (row.siblings.length > 0) {
        let learnerSiblings = row.person.get('learner.siblings');
        row.siblings.forEach((sibling) => {
          learnerSiblings.createFragment({
            schoolId: this.session.activeSchool,
            personId: sibling.id,
          });
        });
        promises.push(row.person.save());
      }
    });
    Promise.all(promises).finally(() => {
      this.isProcessing = false;
      this.paperToaster.show(`Sibling links updated.`, {
        duration: 4000,
        position: 'top right',
        toastClass: 'success',
      });
      this.model.refresh();
    });
  }
}
